export const supplements = [
  { id: 1, name: 'ZINC', price: 30, image: 'https://longevity20155.sirv.com/zinc/1.webp',link:"zinc" },
  { id: 2, name: 'TESTO', price: 35, image: 'https://longevity20155.sirv.com/testo/1.webp',link:"testo" },
  { id: 3, name: 'MINCI', price: 30, image: 'https://longevity20155.sirv.com/minci/1.webp',link:"minci" },
  { id: 4, name: 'ZINC PLUS', price: 40, image: 'https://longevity20155.sirv.com/zinc/2.webp',link:"zinc" },
  { id: 5, name: 'TESTO BOOST', price: 45, image: 'https://longevity20155.sirv.com/testo/2.webp',link:"testo" },
  { id: 6, name: 'MINCI PRO', price: 38, image: 'https://longevity20155.sirv.com/minci/2.webp',link:"minci" },
];
